import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2TourRegisterProperties extends BasicDialogProperties {
    public tournamentId: number = 0;
    public tournamentName: string;
    public goldFee: number = NaN;
    public chipsFee: number = NaN;
    public functionOk: Function;

    constructor(tournamentId: number, tournamentName: string, chipsFee: number, goldFee: number, functionOk: Function) {
        super();

        this.tournamentId = tournamentId;
        this.tournamentName = tournamentName;
        this.goldFee = goldFee;
        this.chipsFee = chipsFee;
        this.functionOk = functionOk;
    }
}
